// src/pages/Home.js
import TopNavBar from '../../components/TopNavBar/TopNavBar';
import { useEffect, useMemo, useState } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
//import { InteractivityDetect } from "@tsparticles/engine";
import { Container } from "@tsparticles/engine";
import { loadAll } from "@tsparticles/all"; // if you are going to use `loadAll`, install the "@tsparticles/all" package too.
//import { loadFull } from "tsparticles"; // if you are going to use `loadFull`, install the "tsparticles" package too.
//import { loadSlim } from "@tsparticles/slim"; // if you are going to use `loadSlim`, install the "@tsparticles/slim" package too.
// import { loadBasic } from "@tsparticles/basic"; // if you are going to use `loadBasic`, install the "@tsparticles/basic" package too.
import OverlayLink from './OverlayLink';
import styles from './Home.module.css';
import newAfrica from '../../assets/overlay-link/newAfrica.png';
import newMap from '../../assets/overlay-link/newMap.png';
import newStream from '../../assets/overlay-link/newStream.png';
import newMoon from '../../assets/overlay-link/newMoon.png';
import newBiodiv from '../../assets/overlay-link/newBiodiv.png';
import newMethane from '../../assets/overlay-link/newMethane.png';

const Home = () => {
  const [init, setInit] = useState(false);

  // this should be run only once per application lifetime
  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadAll(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  const particlesLoaded = async (container?: Container) => {
    console.log(container);
  };

  const options = useMemo(
    () => ({
        "autoPlay": true,
        "background": {
          "color": {
            "value": "#2FCFF7" //background of page
          },
          "opacity": 1
        },
        "clear": true,
        "delay": 0,
        "fullScreen": {
          "enable": true,
          "zIndex": 0
        },
        "detectRetina": true,
        "duration": 0,
        "fpsLimit": 120,
        "interactivity": {
          "detectsOn": "window" as const,
          "events": {
            "onClick": {
              "enable": false,
              "mode": "bubble"
            },
            // "onDiv": {
            //   "selectors": {},
            //   "enable": false,
            //   "mode": {},
            //   "type": "circle"
            // },
            "onHover": {
              "enable": true,
              "mode": "bubble",
              "parallax": {
                "enable": false,
                "force": 2,
                "smooth": 10
              }
            },
            "resize": {
              "delay": 3.0,
              "enable": true
            }
          },
          "modes": {
            "trail": {
              "delay": 1,
              "pauseOnStop": false,
              "quantity": 1
            },
            "attract": {
              "distance": 200,
              "duration": 0.4,
              "easing": "ease-out-quad",
              "factor": 1,
              "maxSpeed": 40,
              "speed": 1
            },
            "bounce": {
              "distance": 200
            },
            "bubble": {
              "distance": 400,
              "duration": 2,
              "mix": true,
              "opacity": 0.3,
              "color": {
                "value": "#5203fc" // bubbles turn purplish when hovered
              },
              "size": 40,
              "divs": {
                "distance": 200,
                "duration": 0.4,
                "mix": false,
                "selectors": {}
              }
            },
            "repulse": {
              "distance": 50, //distance from bubble that it is repulsed
              "duration": 0.4,
              "factor": 100,
              "speed": 0.2,
              "maxSpeed": 10,
              "easing": "ease-out-quad",
              "divs": {
                "distance": 200,
                "duration": 0.4,
                "factor": 100,
                "speed": 1,
                "maxSpeed": 10,
                "easing": "ease-out-quad",
                "selectors": {}
              }
            },
            "slow": {
              "factor": 3,
              "radius": 200
            },
            "light": {
              "area": {
                "gradient": {
                  "start": {
                    "value": "#ffffff"
                  },
                  "stop": {
                    "value": "#000000"
                  }
                },
                "radius": 1000
              },
              "shadow": {
                "color": {
                  "value": "#000000"
                },
                "length": 2000
              }
            }
          }
        },
        "particles": {
          "bounce": {
            "horizontal": {
              "value": 1
            },
            "vertical": {
              "value": 1
            }
          },
          "collisions": {
            "absorb": {
              "speed": 2
            },
            "bounce": {
              "horizontal": {
                "value": 1
              },
              "vertical": {
                "value": 1
              }
            },
            "enable": false,
            "maxSpeed": 10,
            //"mode": "bounce",
            "overlap": {
              "enable": true,
              "retries": 0
            }
          },
          "color": {
            "value": "#188c41",
            "animation": {
              "h": {
                "count": 0,
                "enable": false,
                "speed": 0.3,
                "decay": 0,
                "delay": 0,
                "sync": true,
                "offset": 0
              },
              "s": {
                "count": 0,
                "enable": false,
                "speed": 0.3,
                "decay": 0,
                "delay": 0,
                "sync": true,
                "offset": 0
              },
              "l": {
                "count": 0,
                "enable": false,
                "speed": 0.3,
                "decay": 0,
                "delay": 0,
                "sync": true,
                "offset": 0
              }
            }
          },
          "effect": {
            "close": true,
            "fill": true,
            "options": {},
            //"type": {}
          },
          "move": {
            "angle": {
              "offset": 0,
              "value": 90
            },
            "attract": {
              "distance": 200,
              "enable": false,
              "rotate": {
                "x": 3000,
                "y": 3000
              }
            },
            "center": {
              "x": 50,
              "y": 50,
              //"mode": "percent",
              "radius": 0
            },
            "decay": 0,
            "distance": {},
            //"direction": "none",
            "drift": 0,
            "enable": true,
            "gravity": {
              "acceleration": 9.81,
              "enable": false,
              "inverse": false,
              "maxSpeed": 10
            },
            "path": {
              "clamp": true,
              "delay": {
                "value": 0
              },
              "enable": false,
              "options": {}
            },
            // "outModes": {
            //   "default": "out"
            // },
            "random": false,
            "size": false,
            "speed": 3,
            "spin": {
              "acceleration": 0,
              "enable": false
            },
            "straight": false,
            "trail": {
              "enable": false,
              "length": 10,
              "fill": {}
            },
            "vibrate": false,
            "warp": false
          },
          "number": {
            "density": {
              "enable": true,
              "value_area": 2966.312312601217
            },
            "limit": {
              //"mode": "delete",
              "value": 0
            },
            "value": 40
          },
          "opacity": {
            "value": {
              "min": 0.2,
              "max": 0.6
            },
            "animation": {
              "count": 0,
              "enable": false,
              "speed": 0.5,
              "decay": 0,
              "delay": 0,
              "sync": false,
              //"mode": "auto",
              //"startValue": "random",
              //"destroy": "none"
            }
          },
          "reduceDuplicates": false,
          "shadow": {
            "blur": 0,
            "color": {
              "value": "#000"
            },
            "enable": false,
            "offset": {
              "x": 0,
              "y": 0
            }
          },
          "shape": {
            "close": true,
            "fill": true,
            "options": {
              "polygon": {
                "sides": 6
              }
            },
            "type": "circle"
          },
          "size": {
            "value": {
              "min": 100,
              "max": 160
            },
            "animation": {
              "count": 0,
              "enable": false,
              "speed": 1,
              "decay": 0,
              "delay": 0,
              "sync": false,
              //"mode": "auto",
              //"startValue": "random",
              //"destroy": "none"
            }
          },
          "stroke": {
            "width": 1.5 //outline of bubble
          },
          "zIndex": {
            "value": 0,
            "opacityRate": 1,
            "sizeRate": 1,
            "velocityRate": 1
          },
          "destroy": {
            "bounds": {},
            "mode": "none",
            "split": {
              "count": 1,
              "factor": {
                "value": 3
              },
              "rate": {
                "value": {
                  "min": 4,
                  "max": 9
                }
              },
              "sizeOffset": true
            }
          },
          "twinkle": {
            "lines": {
              "enable": false,
              "frequency": 0.05,
              "opacity": 1
            },
            "particles": {
              "enable": false,
              "frequency": 0.05,
              "opacity": 1
            }
          },
          "wobble": {
            "distance": 5,
            "enable": false,
            "speed": {
              "angle": 50,
              "move": 10
            }
          },
          "life": {
            "count": 0,
            "delay": {
              "value": 0,
              "sync": false
            },
            "duration": {
              "value": 0,
              "sync": false
            }
          },
          "rotate": {
            "value": 0,
            "animation": {
              "enable": false,
              "speed": 0,
              "decay": 0,
              "sync": false
            },
            "direction": "clockwise",
            "path": false
          },
          "orbit": {
            "animation": {
              "count": 0,
              "enable": false,
              "speed": 1,
              "decay": 0,
              "delay": 0,
              "sync": false
            },
            "enable": false,
            "opacity": 1,
            "rotation": {
              "value": 45
            },
            "width": 1
          },
          "repulse": {
            "value": 0,
            "enabled": false,
            "distance": 1,
            "duration": 1,
            "factor": 1,
            "speed": 1
          }
        },
        "pauseOnBlur": true,
        "pauseOnOutsideViewport": true,
        "smooth": false,
        "style": {},
        "zLayers": 100,
        "name": "Bubble",
        "motion": {
          "disable": false,
          "reduce": {
            "factor": 4,
            "value": true
          }
        }
    }),
    [],
  );

  if (init) {
    return (
        <div className={styles.homeContainer}>
            <TopNavBar />
            <Particles
            id="tsparticles"
            particlesLoaded={particlesLoaded}
            options={options}
            />
            <div className={styles.overlayGrid}>
              <OverlayLink
                title="Geography Quiz!"
                text="Test your knowledge of Geography"
                link="/world-countries-quiz"
                imageSrc={newAfrica}
              />
              <OverlayLink
                title="Interactive Fun!"
                text="Take a break and have some play time"
                link="/labs"
                imageSrc={newMethane}
              />
              <OverlayLink
                title="Bird Maps!"
                text="Check out the most recent sightings at local hotspots"
                link="/bird-map"
                imageSrc={newMap}
              />
              <OverlayLink
                title="Stream Health!"
                text="IDetermine a stream's biotic index"
                link="/biotic-index"
                imageSrc={newStream}
              />
              <OverlayLink
                title="Moon Phases!"
                text="Test your knowledge of the Moon's phases"
                link="/moon-cards"
                imageSrc={newMoon}
              />
              <OverlayLink
                title="Biodiversity!"
                text="Determin a forest's index of biodiversity"
                link="/forest-diversity"
                imageSrc={newBiodiv}
              />
            </div>
        </div>
    );
  }

  return <></>;
};
  
export default Home;
